import { render, staticRenderFns } from "./CarModel.vue?vue&type=template&id=9b214916&scoped=true"
import script from "./CarModel.vue?vue&type=script&lang=ts"
export * from "./CarModel.vue?vue&type=script&lang=ts"
import style0 from "./CarModel.vue?vue&type=style&index=0&id=9b214916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b214916",
  null
  
)

export default component.exports